import { render, staticRenderFns } from "./BaseTruncatedField.vue?vue&type=template&id=eaf2f98e&scoped=true&"
import script from "./BaseTruncatedField.vue?vue&type=script&lang=js&"
export * from "./BaseTruncatedField.vue?vue&type=script&lang=js&"
import style0 from "./BaseTruncatedField.vue?vue&type=style&index=0&id=eaf2f98e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf2f98e",
  null
  
)

export default component.exports